<ion-header>
  <ion-toolbar mode="md"
               color="dark">
    <ion-title>{{ 'pos.discounts' | transloco }}</ion-title>
    <ion-buttons slot="end">
      <ion-button mode="md"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onCloseModal()">{{ 'common.close' | transloco }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content fullscreen>
  <div class="discounts-modal">
    <ion-toolbar mode="md" color="orange" class="subheader">
      <ion-title>{{ 'pos.onlyOneDiscountAllowed' | transloco }}</ion-title>
    </ion-toolbar>
    <ion-list class="discounts">
      <ion-item *ngFor="let item of discounts"
                class="discounts__item">
        <ion-label class="discounts__item__name">
          <h2>
            <strong>{{item.name}}</strong>
          </h2>
        </ion-label>
        <ion-button *ngIf="!selectedDiscountId || selectedDiscountId !== item.id"
                    mode="md"
                    color="dark"
                    [disabled]="selectedDiscountId"
                    debounce-click
                    [debounceTime]="0"
                    (debounceClick)="onAddDiscount(item)">{{ 'common.add' | transloco | uppercase }}</ion-button>
        <ion-button *ngIf="selectedDiscountId && selectedDiscountId === item.id"
                    mode="md"
                    color="danger"
                    debounce-click
                    [debounceTime]="0"
                    (debounceClick)="onRemoveDiscount(item)">{{ 'common.remove' | transloco | uppercase }}</ion-button>
      </ion-item>
    </ion-list>
  </div>
</ion-content>
